import React, { useContext, useMemo, useState } from 'react';
import { cookieExist, setCookie } from '../../browser-cookies';
import { AppContext } from '../../../Store';
import { NicknameFieldContext } from '../../../state-management/contexts/regform-fields/nickname-field-context';
import { PasswordFieldContext } from '../../../state-management/contexts/regform-fields/password-field-context';
import { TermsCheckboxContext } from '../../../state-management/contexts/regform-checkboxes/terms-checkbox-context';
import { COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE } from '../../cookie-overlay';
import { useTranslation } from 'react-i18next';
import { EmailFieldContext } from '../../../state-management/contexts/regform-fields/email-field-context';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';
import { registerWithAllFields } from '../../form-registrations';

export const withOneStepValidationWithAllFields = function(Component) {
	const EnhancedComponent = function({ ...props }) {
		const [state, dispatch] = useContext(AppContext);
		const onelpsParams = useContext(OneLPSsdkParamsContext);
		const [nicknameState, nicknameDispatch] = useContext(NicknameFieldContext);
		const [passwordState, passwordDispatch] = useContext(PasswordFieldContext);
		const [emailState, emailDispatch] = useContext(EmailFieldContext);
		const [termsState, termsDispatch] = useContext(TermsCheckboxContext);

		const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

		const { t } = useTranslation('translation');
		const hasRaceSelection = useMemo(() => onelpsParams.raceSelection?.show, [onelpsParams.raceSelection]);

		const handlePlayClick = async (e) => {
			e ? e.preventDefault() : null;

			setShowLoadingIndicator(true);

			if (!nicknameState.value) {
				nicknameDispatch({ type: 'SET_NICKNAME_ERROR', payload: t('form.username.errorMessages.errorMessageEmpty') });
				nicknameDispatch({ type: 'SHOW_NICKNAME_ERROR' });

				setShowLoadingIndicator(false);
			}

			if (!emailState.value) {
				emailDispatch({ type: 'SET_EMAIL_ERROR', payload: t('form.email.errorMessages.errorMessageEmpty') });
				emailDispatch({ type: 'SHOW_EMAIL_ERROR' });

				setShowLoadingIndicator(false);
			}

			if (!passwordState.value) {
				passwordDispatch({ type: 'SET_PASSWORD_ERROR', payload: t('form.password.errorMessages.errorMessageEmpty') });
				passwordDispatch({ type: 'SHOW_PASSWORD_ERROR' });

				setShowLoadingIndicator(false);
			}

			if (!termsState.value) {
				termsDispatch({ type: 'SET_TC_ERROR', payload: t('form.terms.errorMessages.errorMessageEmpty') });
				termsDispatch({ type: 'SHOW_TC_ERROR' });

				setShowLoadingIndicator(false);
			}

			if (nicknameState.value && emailState.value && passwordState.value && termsState.value &&
						!nicknameState.error.message &&
						!emailState.error.message &&
						!passwordState.error.message &&
						!termsState.error.message
			) {
				nicknameDispatch({ type: 'HIDE_NICKNAME_ERROR' });
				emailDispatch({ type: 'HIDE_EMAIL_ERROR' });
				passwordDispatch({ type: 'HIDE_PASSWORD_ERROR' });
				termsDispatch({ type: 'HIDE_TC_ERROR' });

				if (!cookieExist(COOKIE_NOTIFICATION_NAME)) {
					setCookie(COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE);
					dispatch({ type: 'HIDE_COOKIE_OVERLAY' });
					dispatch({ type: 'MARK_TRACKING_EXECUTED' });
				}

				if (hasRaceSelection) {
					dispatch({ type: 'SHOW_RACE_SELECTION' });
				} else {
					await registerWithAllFields(
						state.locale, dispatch, nicknameDispatch, passwordDispatch, emailDispatch, termsDispatch,
						nicknameState.value, passwordState.value, emailState.value, termsState.value,
						state.thirdPartyTrackingAccepted,
					);
				}
			}
			else {
				setShowLoadingIndicator(false);
			}
		};

		return (
			<Component
				{...props}
				handlePlayClick={handlePlayClick}
				showLoadingIndicator={showLoadingIndicator}
			/>
		);
	};
	EnhancedComponent.displayName = 'componentWithValidation';
	return EnhancedComponent;
};
